class InfiniteScrollCollection extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById('product-grid');
      this.paginationWrapper = document.getElementById('ProductGridPagination');
      this.loading = false;

      if (!this.grid || !this.paginationWrapper) return;

      this.sectionId = this.paginationWrapper.dataset.sectionId;

      this.injectSentinel();
      this.hideDefaultPagination();
      this.observeSentinel();
    }

    // Hide Dawn's default numbered pagination links (we still keep them in DOM
    // as our source of truth for "next page url" — just visually hidden)
    hideDefaultPagination() {
      this.paginationWrapper.style.display = 'none';
    }

    injectSentinel() {
        this.sentinel = document.createElement('div');
        this.sentinel.id = 'infinite-scroll-sentinel';
        this.sentinel.innerHTML = `
            <div class="infinite-scroll-loader" hidden>
            <span class="infinite-scroll-loader__spinner"></span>
            <span class="infinite-scroll-loader__text">Loading</span>
            </div>
        `;
        this.paginationWrapper.insertAdjacentElement('afterend', this.sentinel);
    }

    getNextUrl() {
      const nextLink = this.paginationWrapper.querySelector('a.pagination__item--prev');
      return nextLink ? nextLink.getAttribute('href') : null;
    }

    observeSentinel() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !this.loading) {
            this.loadNextPage();
          }
        },
        { rootMargin: '600px 0px 0px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    async loadNextPage() {
        const nextUrl = this.getNextUrl();
        if (!nextUrl) {
            this.finishNoMorePages();
            return;
        }

        this.loading = true;
        const spinner = this.sentinel.querySelector('.infinite-scroll-loader');
        spinner.hidden = false;

        try {
            const url = new URL(nextUrl, window.location.origin);
            url.searchParams.set('section_id', this.sectionId);

            // Fetch the next page AND wait at least 3 seconds — whichever takes longer.
            // This guarantees the "Loading" text is visible for a full 3s even if
            // the fetch itself is fast.
            const [response] = await Promise.all([
            fetch(url.toString()),
            new Promise((resolve) => setTimeout(resolve, 2000))
            ]);

            if (!response.ok) throw new Error('Fetch failed: ' + response.status);
            const html = await response.text();

            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newGrid = doc.getElementById('product-grid');
            const newPagination = doc.getElementById('ProductGridPagination');

            if (newGrid) {
            this.grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            }

            if (newPagination) {
            this.paginationWrapper.innerHTML = newPagination.innerHTML;
            } else {
            this.paginationWrapper.innerHTML = '';
            }

            if (!this.getNextUrl()) {
            this.finishNoMorePages();
            }

            this.dispatchEvent(new CustomEvent('infinite-scroll:appended', { bubbles: true }));
        } catch (err) {
            console.error('Infinite scroll load failed:', err);
            this.finishNoMorePages();
        } finally {
            spinner.hidden = true;
            this.loading = false;
        }
    }

    finishNoMorePages() {
      if (this.observer) this.observer.unobserve(this.sentinel);
      this.sentinel.remove();
    }
  }

  customElements.define('infinite-scroll-collection', InfiniteScrollCollection);